import { KfcCheckout } from "../components/KfcCheckout.js"; 

// KFC 菜單中每個選項
export const CartMenuGroup = (props) => {
  return (
    <div className="cartMenuGroup">
      <div className="cartMenu">
        <img alt="" src={props.img}></img>
      </div>
      <h6 className="cartMenuName">{props.name}</h6>
      <h6 className="cartMenuPrice">
        ${props.price}
        <span className="AddShopping">
          <KfcCheckout items={props}/>
        </span>
      </h6>
    </div>);
};
